


























import { PropType } from 'vue';
import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import SingleImage from './SingleImage.vue';

interface IBlok {
  PlaceholderImage?: {
    filename?: string;
  };
  filename?: string;
  YouTubeLink?: {
    url?: string;
  };
}

export default defineComponent({
  name: 'YouTubeVideo',
  components: {
    SingleImage,
  },
  props: {
    blok: {
      type: Object as PropType<IBlok>,
      required: true,
    },
  },
  setup({ blok }: { blok: IBlok }) {
    const youTubeEmbedLink = ref('');
    const isIframe = ref(false);
    const autoplayQuery = '?autoplay=1&mute=1';

    const paddingTop = ref('');

    const createYouTubeEmbedLink = () => {
      const url = new URL(blok.YouTubeLink.url);
      const searchParams = new URLSearchParams(url.search);
      const videoId = searchParams.get('v');
      youTubeEmbedLink.value = blok.PlaceholderImage.filename
        ? `https://www.youtube.com/embed/${videoId}${autoplayQuery}`
        : `https://www.youtube.com/embed/${videoId}`;
    };

    const loadIframe = () => {
      isIframe.value = true;
    };

    onMounted(() => {
      createYouTubeEmbedLink();
    });

    return {
      youTubeEmbedLink,
      isIframe,
      autoplayQuery,
      paddingTop,
      createYouTubeEmbedLink,
      loadIframe,
    };
  },
});
